<template>
  <div class="chargingPileMonitoring">
    <div class="p-title">
      <div>充电桩监测</div>
    </div>
    <div class="content">
      <div class="content_list">
        <LeftList
            :list="list"
            :isSelectId.sync="isSelectId"
            :detail.sync="detail"></LeftList>
      </div>
      <div class="content_content">
        <RightContent :detail="detail"></RightContent>
      </div>
    </div>
  </div>
</template>

<script>
import LeftList from "./componnets/list.vue"
import RightContent from "./componnets/right.vue"
import icon1 from "../../assets/img/icon1.png"
import icon1_active from "../../assets/img/icon1_active.png"

export default {
  name: "ChargingPileMonitoring",
  components: {
    LeftList,
    RightContent
  },
  created() {
    this.detail = {...this.list[0].children[0], parent: this.list[0].name}
  },
  data() {
    return {
      isSelectId: '0-1',
      detail: {},
      list: [
        {
          id: 0,
          name: '车棚充电站1',
          children: [
            {
              id: '0-1',
              name: '交流桩1',
              type: 'AC',
              img: icon1,
              img_a: icon1_active
            }, {
              id: '0-2',
              name: '交流桩2',
              type: 'AC',
              img: icon1,
              img_a: icon1_active
            }, {
              id: '0-3',
              name: '交流桩3',
              type: 'AC',
              img: icon1,
              img_a: icon1_active
            }, {
              id: '0-4',
              name: '交流桩4',
              type: 'AC',
              img: icon1,
              img_a: icon1_active
            }, {
              id: '0-5',
              name: '交流桩5',
              type: 'AC',
              img: icon1,
              img_a: icon1_active
            }, {
              id: '0-6',
              name: '直流桩1',
              type: 'DC',
              img: icon1,
              img_a: icon1_active
            }, {
              id: '0-7',
              name: '直流桩2',
              type: 'DC',
              img: icon1,
              img_a: icon1_active
            },
          ]
        },
        {
          id: 1,
          name: '车棚充电站2',
          children: [
            {
              id: '1-1',
              name: '交流桩1',
              type: 'AC'
            }, {
              id: '1-2',
              name: '交流桩2',
              type: 'AC'
            }, {
              id: '1-3',
              name: '交流桩3',
              type: 'AC'
            }, {
              id: '1-4',
              name: '交流桩4',
              type: 'AC'
            }, {
              id: '1-5',
              name: '交流桩5',
              type: 'AC'
            }, {
              id: '1-6',
              name: '直流桩1',
              type: 'DC'
            }, {
              id: '1-7',
              name: '直流桩2',
              type: 'DC'
            },
          ]
        }
      ]
    }
  }
}
</script>

<style scoped lang="less">
.chargingPileMonitoring {
  height: 100%;
  background-color: #fff;
  overflow: hidden;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, .12);
  font-size: 18rem;

  .p-title {
    height: 49rem;
    border-bottom: 1px solid rgba(0, 0, 0, .12);
    padding: 0 25rem;
    font-weight: bold;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .el-icon-close {
      width: 17rem;
    }
  }

  .content {
    display: flex;
    height: calc(100% - 50rem);
    padding: 16rem 0;

    .content_list {
      width: 25%;
      height: 100%;
      border-right: 1px solid rgba(0, 0, 0, .12);
      padding: 0 24rem;
    }

    .content_content {
      width: 75%;
      padding: 0 24rem;
    }
  }
}

</style>